import { HelpersService } from './helpers.service';

export default angular
  .module('sfMobile.services.helpers', [
    'sfMobile.services.dates',
    'sfMobile.services.profile',
  ])
  .factory('helpersService', HelpersService).name;
